const config = {
  production : {
    url : '//' + location.host + '/api',
    url_v4: `//${location.host}/api/v4`,
    baseUrl : '//' + location.host + '/',
    socketCluster: {
      "hostname": location.host,
      "protocol": 'https',
      "port": 443
    }
  },
  staging : {
    url : '//' + location.host + '/api',
    baseUrl : '//' + location.host + '/',
    socketCluster: {
      "hostname": location.host,
      "protocol": 'https',
      "port": 443
    }
  },
  local : {
    url : "http://localhost:3001/api",
    "url_v4":"http://localhost:3004/api/v4",
    baseUrl : "http://localhost:8080/",
    socketCluster: {
      "hostname":"localhost",
      "protocol":"http",
      "port":3002
    }
  }
}

export default config[process.env.NODE_ENV || 'local'];



// WEBPACK FOOTER //
// ./src/config/index.js